import i18n from "./index";

const loadedLanguages = ["en-US"];

function setI18nLanguage(lang) {
  let newLang = lang;
  i18n.locale = newLang;
  document.querySelector("html").setAttribute("lang", newLang);

  return newLang;
}

/**
 * Import the file on the fly and set as default loacel.
 *
 * @param {String} lang
 * @returns
 */
const handler = async lang => {
  if (i18n.locale === lang) {
    return await setI18nLanguage(lang);
  }

  if (loadedLanguages.includes(lang)) {
    return await setI18nLanguage(lang);
  }

  return import(/* webpackChunkName: "lang-[request]" */ "./languages/" +
    lang +
    ".json").then(messages => {
    i18n.setLocaleMessage(lang, messages.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
};

export default handler;
